import { render, staticRenderFns } from "./publicpic.vue?vue&type=template&id=30484032&scoped=true&"
import script from "./publicpic.vue?vue&type=script&lang=js&"
export * from "./publicpic.vue?vue&type=script&lang=js&"
import style0 from "./publicpic.vue?vue&type=style&index=0&id=30484032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30484032",
  null
  
)

export default component.exports